import React from "react";

import Header from "../../components/header/Header";
import Hero from "../../components/hero/Hero";
import Footer from "../../components/footer/Footer";
import LeagueLogos from "../../components/hero/LeagueLogos";
import HeroImage from "../../components/hero/HeroImage";
import UpToButton from "../../components/upToButton/UpToButtom";
import PopOverMenu from "../../components/ArticleItem/PopOverMenu";
import { useSelector } from "react-redux";
import { InitialState } from "../../store/ArticleStore";
import { RootState } from "../../store/store";

interface BaseLayoutProps {
  children: React.ReactNode;
  leagueLogoActive?: boolean;
  isNavigation?: boolean;
  customHeroClass?: string;
}

function BaseLayout({ children, leagueLogoActive = false, isNavigation = true, customHeroClass  }: BaseLayoutProps) {

  const { articleData } = useSelector(
    (state: RootState) => state.articleStore as InitialState
  ); 

  return (
    <>
      <Header isNavigation={isNavigation}>
        <a href="/">
          <div className='logos-container'>
            <img src={`${process.env.PUBLIC_URL}/assets/logos/signet-wasserball-frauen@2x.webp`}
              alt='frauen wasserball liga logo' width={64} height={64} />
            <img src={`${process.env.PUBLIC_URL}/assets/logos/signet-wasserball-maenner@2x.webp`}
              alt='männer wasserball liga logo' width={64} height={64} />
            <img src={`${process.env.PUBLIC_URL}/assets/logos/Wasserball_Bundesliga_schriftzug@2x.webp`}
              alt='schriftzug wasserball liga' width={187} height={64} />
          </div>
        </a>
      </Header>
       {Array.isArray(articleData) && articleData[0]?.isShared && (
        <div
          className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-slate-100 rounded-lg shadow-lg popover-layer"
          >
            <PopOverMenu articleSlug={articleData[0]?.articleslug} />
          </div>
        </div>
      )}
      
      <Hero customClass={customHeroClass}>
        <>
          <HeroImage/>
          {leagueLogoActive &&
            <LeagueLogos/>
          }
        </>
      </Hero>
      <main>
        {children}
      </main>
      <Footer>
        <UpToButton/>
      </Footer>
    </>
  );
}

export default BaseLayout;